import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { selectApps } from '../../selectors/applications';
import { selectAccess } from '../../selectors/auth';

function AppMenu(props) {
  const { apps, anchorEl, isOpen, onClose, access } = props;

  const installedApps = apps.filter(app => {
    const isSubscribedOrAvailable = app.isSubscribed || app.isAvailable;
    // so internal users don't need client membership
    if (access.isInternal && isSubscribedOrAvailable) return true;
    return app.isSubscribed;
  });
  return (
    <>
      <Menu
        getContentAnchorEl={null}
        id="simple-menu"
        anchorEl={anchorEl}
        open={isOpen}
        keepMounted
        onClose={onClose}
      >
        {installedApps.map(app => {
          const logo = require(`../../assets/images/${app.meta.logo}`); // eslint-disable-line import/no-dynamic-require, global-require
          return (
            <MenuItem
              component="a"
              key={app.id}
              href={app.meta.link}
              target="_blank"
              onClick={onClose}
            >
              <img src={logo} alt={app.name} style={{ maxHeight: '1.5em' }} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
AppMenu.defaultProps = {
  apps: [{}],
  anchorEl: {},
  isOpen: false,
  onClose: () => {},
  access: {},
};

AppMenu.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string,
        description: PropTypes.string,
        auth: PropTypes.shape({
          default: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])),
        }),
        meta: PropTypes.shape({
          logo: PropTypes.string,
          link: PropTypes.string,
          slides: PropTypes.arrayOf(
            PropTypes.oneOfType([
              PropTypes.shape({
                title: PropTypes.string,
                copy: PropTypes.string,
                img: PropTypes.string,
              }),
            ])
          ),
        }),
      }),
    ])
  ),
  anchorEl: PropTypes.instanceOf(Element),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  access: PropTypes.shape({
    isInternal: PropTypes.bool,
  }),
};

const mapStateToProps = createStructuredSelector({
  access: selectAccess(),
  apps: selectApps(),
});

const withConnect = connect(mapStateToProps, () => ({}));

export default compose(withConnect, memo)(AppMenu);
